import { app } from '@/apps'

app.mount('#app')
